module.exports = __webpack_public_path__ + "img/consumption_classic.4a13d6b0.png";